import { Component } from "@angular/core";

@Component({
  selector: "app-nutzungsbedingungen",
  templateUrl: "./nutzungsbedingungen.component.html",
  styleUrls: ["./nutzungsbedingungen.component.scss"],
  standalone: false,
})
export class NutzungsbedingungenComponent {}
